import React from 'react';
import MuiLink from '@material-ui/core/Link';
import { Link } from 'react-router-dom';
import HandlingListStatus from '../../../../components/HandlingListStatus';

export const handlingListFormatter = (cell, row) => (
  <MuiLink variant="subtitle1" component={Link} to={`/handling-lists/${row.id}`}>
    {(row.number && row.number) || row.id}
  </MuiLink>
);

export const statusFormatter = (cell, row) => <HandlingListStatus handlingList={row} />;

export default handlingListFormatter;
